import { useTranslation } from "react-i18next";

export type HomeTab = "owned" | "shared";

interface HomeTabsProps {
  activeTab: HomeTab;
  onTabChange: (tab: HomeTab) => void;
  unopenedCount?: number;
}

interface TabConfig {
  id: HomeTab;
  labelKey: string;
  testId: string;
}

const TABS: TabConfig[] = [
  {
    id: "owned",
    labelKey: "tabs.yourManuscripts",
    testId: "home-tab-owned",
  },
  {
    id: "shared",
    labelKey: "tabs.sharedWithMe",
    testId: "home-tab-shared",
  },
];

export const HomeTabs = ({
  activeTab,
  onTabChange,
  unopenedCount = 0,
}: HomeTabsProps) => {
  const { t } = useTranslation("sharing");

  return (
    <div
      data-testid="home-tabs"
      className="p-1 h-9 rounded-lg flex items-center w-fit"
      style={{
        background:
          "linear-gradient(0deg, rgba(255, 255, 255, 0.40) 0%, rgba(255, 255, 255, 0.40) 100%), #F1F5F9",
      }}
    >
      {TABS.map((tab) => {
        const isActive = activeTab === tab.id;
        const showCount = tab.id === "shared" && unopenedCount > 0;
        return (
          <button
            key={tab.id}
            type="button"
            data-testid={tab.testId}
            onClick={() => onTabChange(tab.id)}
            className={`flex py-1 px-6 justify-center items-center gap-2 min-w-[10rem] border-0 rounded-lg text-sm font-[450] leading-5 transition-colors ${
              isActive
                ? "bg-white text-foreground shadow"
                : "text-secondary-600 hover:text-foreground"
            }`}
          >
            <span>{t(tab.labelKey)}</span>
            {showCount && (
              <span
                aria-label="unopened count"
                className="inline-flex h-4 min-w-[1rem] items-center justify-center rounded-2xl bg-primary-500 px-1 text-[0.65rem] font-medium text-white"
              >
                {unopenedCount}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};
